import { useTranslation } from 'react-i18next';

const AppearanceCrumb = () => {
    const { t } = useTranslation();
    return <>{t('userSettings.appearance.title')}</>;
};

export default AppearanceCrumb;
